/** Volto Project Configuration
 * The recommended way for configuring a Volto project is using an add-on.
 * The project should only be considered as boilerplate, and all the code and
 * configuration should happen and be placed in add-ons.
 *
 * Both configuring directly and placing code in a project is discouraged, and might be
 * removed at some point from Volto.
 *
 * The local project is left for backwards compatibility for existing projects.
 */

// [Internal] All the imports of modules required for the configuration *must* happen
// here BEFORE the following line
import '@plone/volto/config';
import SSRCrash from './views/SSRCrash';

export default function applyConfig(config) {
  // Add SSR crash test route for Sentry testing
  config.addonRoutes = [
    ...(config.addonRoutes || []),
    {
      path: '/_crash-ssr',
      component: SSRCrash,
      exact: true,
    },
  ];
  
  return config;
}
